import { Input } from "@/marketing/components/ui/input";

import type { AffiliateTermsFormState } from "./affiliateTermsForm";

interface AffiliateTermsFieldsProps {
  form: AffiliateTermsFormState;
  errors: string[];
  onChange: (changes: Partial<AffiliateTermsFormState>) => void;
}

interface AffiliateTermsInput {
  field: keyof AffiliateTermsFormState;
  label: string;
  step: string;
}

const INPUTS: AffiliateTermsInput[] = [
  { field: "discountPercent", label: "Customer discount %", step: "1" },
  { field: "couponPercent", label: "Code commission %", step: "0.1" },
  { field: "utmPercent", label: "Link commission %", step: "0.1" },
  { field: "couponUtmPercent", label: "Code + link commission %", step: "0.1" },
];

/** Per-campaign affiliate discount and commission rates; a blank field keeps the programme default. */
export function AffiliateTermsFields({ form, errors, onChange }: AffiliateTermsFieldsProps) {
  return (
    <div className="tw-rounded-md tw-border tw-border-border tw-p-3">
      <p className="tw-mb-1 tw-text-xs tw-font-semibold tw-text-foreground/80">Affiliate terms</p>
      <p className="tw-mb-3 tw-text-[12px] tw-text-muted-foreground">
        Leave a field blank to use the programme default. A discount change applies to codes issued after it; a
        commission change applies to sales recorded after it.
      </p>
      <div className="tw-grid tw-grid-cols-2 tw-gap-3">
        {INPUTS.map(({ field, label, step }) => (
          <div key={field}>
            <label className="tw-mb-1 tw-block tw-text-xs tw-text-foreground/80">{label}</label>
            <Input
              aria-label={label}
              type="number"
              min={field === "discountPercent" ? 1 : 0}
              max={100}
              step={step}
              value={form[field]}
              onChange={(e) => onChange({ [field]: e.target.value })}
              placeholder="Default"
            />
          </div>
        ))}
      </div>
      {errors.length > 0 && (
        <ul className="tw-mt-2 tw-space-y-0.5 tw-text-xs tw-text-red-600">
          {errors.map((error) => (
            <li key={error}>{error}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
